import { h } from 'preact';

const Giphy = (props) => {
	return (
		<svg {...props} viewBox="-5 -4 24 24" xmlns="http://www.w3.org/2000/svg">
			<path d="m0 1.3712h1.8648v13.2576h-1.8648z" />
			<path d="m11.1912 7.3305886 1.8648-1.64225527v8.94046667h-1.8648z" />
			<path d="m0 14.1712h13.056v1.8288h-13.056z" />
			<path d="m0 0h7.27453613l-1.27453613 1.8288h-6z" />
			<path d="m11.1912 3.6568v-1.828h-1.8656v-1.8288h-1.8648v5.4856h5.5952v-1.8288" />
		</svg>
	);
};

export default Giphy;